import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import ProtectedRoute from '.';

class BlogRoute extends Route {

  render() {
    if (localStorage.getItem('blog')) {
      return <ProtectedRoute path={this.props.path} component={this.props.component} />
    } else {
      return <Redirect to="/create" />
    }
  }
}

const mapStateToProps = (state) => {
  return {
    blogs: state.blogs
  }
}
export default connect(mapStateToProps)(BlogRoute)